import commonTheme from "./common";
const theme = Object.assign(Object.assign({}, commonTheme), { primaryColor: "#ED1D5F", secondaryColor: "#c20000", fontFamily: "Inter, sans-serif" });
export default theme;
